export default __webpack_public_path__ + "static/media/login-password-icon.5dd8a5fc.svg";